export const FETCH_CUSTOMER_HISTORY_BEGIN = "FETCH_CUSTOMER_HISTORY_BEGIN";
export const FETCH_CUSTOMER_HISTORY_SUCCESS = "FETCH_CUSTOMER_HISTORY_SUCCESS";
export const FETCH_CUSTOMER_HISTORY_FAILURE = "FETCH_CUSTOMER_HISTORY_FAILURE";

export const AGENT_SELECT_CUSTOMER = "AGENT_SELECT_CUSTOMER";

export const AGENT_NEW_REQUEST = "AGENT_NEW_REQUEST";

export const AGENT_SELECTED_CUSTOMER_DOWNLOAD = "AGENT_SELECTED_CUSTOMER_DOWNLOAD";

export const AGENT_DELETE_REQUEST_BEGIN = "AGENT_DELETE_REQUEST_BEGIN";
export const AGENT_DELETE_REQUEST_SUCCESS = "AGENT_DELETE_REQUEST_SUCCESS";
export const AGENT_DELETE_REQUEST_FAILURE = "AGENT_DELETE_REQUEST_FAILURE";

export const AGENT_DOWNLOAD_REQUEST_BEGIN = "AGENT_DOWNLOAD_REQUEST_BEGIN";
export const AGENT_DOWNLOAD_REQUEST_SUCCESS = "AGENT_DOWNLOAD_REQUEST_SUCCESS";
export const AGENT_DOWNLOAD_REQUEST_FAILURE = "AGENT_DOWNLOAD_REQUEST_FAILURE";

export const AGENT_CANCEL_DOWNLOAD_BEGIN = "AGENT_CANCEL_DOWNLOAD_BEGIN";
export const AGENT_CANCEL_DOWNLOAD_SUCCESS = "AGENT_CANCEL_DOWNLOAD_SUCCESS";
export const AGENT_CANCEL_DOWNLOAD_FAILURE = "AGENT_CANCEL_DOWNLOAD_FAILURE";

export const RESET_AGENT_CANCEL_DOWNLOAD_TYPE = "RESET_AGENT_CANCEL_DOWNLOAD_TYPE";
